'use es6';

import events from '../../events.yaml';
const MAX_SECONDS_BEFORE_TIMEOUT = 90;
/**
 * Wait for __hstc cookie to become available before usage tracker can
 * track events
 */

const getTrackerHstc = () => {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      const hasHstc = document.cookie.includes('__hstc=');

      if (hasHstc) {
        clearInterval(interval);
        let hstc = '';

        for (const cookiePair of document.cookie.split(';')) {
          const [key, val] = cookiePair.split('=');

          if (key.trim() === '__hstc') {
            hstc = val.trim();
            break;
          }
        }

        resolve(hstc);
      }
    }, 100);
    setTimeout(() => {
      clearInterval(interval);
    }, MAX_SECONDS_BEFORE_TIMEOUT * 1000);
  });
};

export const getTrackerConfig = () => ({
  events,
  properties: {
    namespace: 'developer-docs',
    hstc: getTrackerHstc
  },
  isExternalHost: false
});